import { userApi } from 'api/user';
import { locationHelpers } from 'utils/helpers/locationHelpers';
import type { TSetState } from 'zustand-toolbox';

import type { TStore } from './types';

const getUserInfo = (set: TSetState<TStore>) => async () => {
    set({ isLoading: true });

    try {
        const user = await userApi.getUserInfo();

        set({ user });

        return user;
    } catch (e) {
        throw e;
    } finally {
        set({ isLoading: false });
    }
};

const logout = (set: TSetState<TStore>) => async () => {
    try {
        await userApi.logout();
        set({ user: null });
    } catch (e) {
        throw e;
    }
};

const changePassword = (set: TSetState<TStore>) => async () => {
    set((state) => ({ ...state, isLoading: true }));

    try {
        const { link } = await userApi.changePassword();

        locationHelpers.replaceLocation(link);
    } catch (e) {
        throw e;
    } finally {
        set((state) => ({ ...state, isLoading: false }));
    }
};

export const actions = {
    getUserInfo,
    logout,
    changePassword,
};
